export default __webpack_public_path__ + "544ad866ae12325ada59ef3f939af9a5.svg";